import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DisplayName } from '../../../app/AppUtils';
import DefaultExcelExport from '../../subcomponents/DefaultExcelExport';

export default function ExportExcelSchoolclass({ disabled, jsonData, showTJL }) {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { siomSettings } = useSelector((state) => state.settings.siom);

    const [excelDataRows, setExcelDataRows] = useState([]);
    const [excelHeaderRow, setExcelHeaderRow] = useState([]);
    const [excelFileName, setExcelFileName] = useState("");

    useEffect(() => {
        if (jsonData) {
            let data = jsonData?.map(({ studentId, ...rest }) => rest);

            // Header row
            let headerRow = [
                `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NUMBER.toLowerCase()}`,
                `${resourceFinal[appLanguage].words.STUDENT}${resourceFinal[appLanguage].words.NAME.toLowerCase()}`
            ];

            if (!siomSettings?.alternateSchoolclassOverview) headerRow.push(resourceFinal[appLanguage].words.PROGRAM);
            if (siomSettings?.enableRequiredPrograms) headerRow.push(resourceFinal[appLanguage].words.REQUIRED_PROGRAM);
            if (siomSettings?.alternateSchoolclassOverview) headerRow.push(resourceFinal[appLanguage].words.POINTS_COMPLETED);
            if (showTJL) headerRow.push(resourceFinal[appLanguage].words.FLAGS_TJL);
            if (siomSettings?.alternateSchoolclassOverview) headerRow.push(resourceFinal[appLanguage].words.POINTS_TO_ACQUIRE);

            headerRow.push(resourceFinal[appLanguage].words.POINTS_ACHIEVED.toLowerCase());

            if (!siomSettings?.alternateSchoolclassOverview) headerRow.push(resourceFinal[appLanguage].words.POINTS_SUBSCRIBED);
            if (!siomSettings?.alternateSchoolclassOverview) headerRow.push(resourceFinal[appLanguage].words.POINTS_NEEDED);

            headerRow.push(resourceFinal[appLanguage].words.FLAGS_YELLOW_MULT);

            if (!siomSettings?.alternateSchoolclassOverview) headerRow.push(resourceFinal[appLanguage].words.ATTENDANCE);

            headerRow.push(resourceFinal[appLanguage].words.REMARKS);

            setExcelHeaderRow(headerRow);

            // Data rows
            let dataRows = [];

            data?.forEach(item => {
                let row = [
                    item.studentData.number,
                    DisplayName(item.studentData.firstName, item.studentData.middleName, item.studentData.lastName)
                ];

                if (!siomSettings?.alternateSchoolclassOverview) row.push(item.studentProgress?.totalProgramCompleted ? resourceFinal[appLanguage].words.EXCEL_GREEN : resourceFinal[appLanguage].words.EXCEL_YELLOW);

                if (siomSettings?.enableRequiredPrograms) {
                    switch (item?.studentProgress?.requiredPoints?.requiredProgramStatus) {
                        case "green":
                            row.push(resourceFinal[appLanguage].words.EXCEL_GREEN); 
                            break;
                        case "yellow":
                            row.push(resourceFinal[appLanguage].words.EXCEL_YELLOW);
                            break;
                        case "red":
                            row.push(resourceFinal[appLanguage].words.EXCEL_RED);
                            break;
                        case "":
                        case null:
                            row.push(resourceFinal[appLanguage].words.EXCEL_GREY);
                            break;
                        default:
                            break;
                    }
                }

                if (siomSettings?.alternateSchoolclassOverview) row.push(item.studentProgress?.totalPoints?.allPointsCompleted ? resourceFinal[appLanguage].words.EXCEL_GREEN : resourceFinal[appLanguage].words.EXCEL_YELLOW);

                if (showTJL) {
                    switch (item?.studentProgress?.progressFlags?.lifestyleStatus) {
                        case 2:
                            row.push(resourceFinal[appLanguage].words.EXCEL_GREEN);
                            break;
                        case 1:
                            row.push(resourceFinal[appLanguage].words.EXCEL_YELLOW);
                            break;
                        case 0:
                        case "":
                        case null:
                            row.push(resourceFinal[appLanguage].words.EXCEL_RED);
                            break;
                        default:
                            break;
                    }
                }

                if (siomSettings?.alternateSchoolclassOverview) row.push(item.studentProgress?.totalPoints?.minPoints);

                row.push(item.studentProgress?.totalPoints?.achievedPoints);

                if (!siomSettings?.alternateSchoolclassOverview) row.push(item.studentProgress?.totalPoints?.subscribedPoints);
                if (!siomSettings?.alternateSchoolclassOverview) row.push(item.studentProgress?.totalPoints?.neededPoints);

                row.push(item.studentProgress?.progressFlags?.flagsYellow);

                if (!siomSettings?.alternateSchoolclassOverview) row.push(item.studentProgress?.progressActivities?.some((item) => item.status === false) ? resourceFinal[appLanguage].words.STATUS_NOT_OK : resourceFinal[appLanguage].words.STATUS_OK,);

                row.push(item.studentProgress?.progressRemarks?.remarksCount);

                dataRows.push(row);
            });

            setExcelDataRows(dataRows);

            // File name
            setExcelFileName(`${!!jsonData[0]?.studentData?.extraInfo?.class ? jsonData[0]?.studentData?.extraInfo?.class : resourceFinal[appLanguage].words.CLASS} ${resourceFinal[appLanguage].words.OVERVIEW}`);
        }
    }, [jsonData]);

    return (
        <DefaultExcelExport
            headerRow={excelHeaderRow}
            dataRows={excelDataRows}
            fileName={excelFileName}
            buttonText={`${resourceFinal[appLanguage].words.EXCEL} ${resourceFinal[appLanguage].words.EXPORT}`}
            disabledCondition={disabled}
        />
    );
}
